import { styled } from '@mui/material';
import type { ComponentProps } from 'react';

export const Svg = styled('svg')({});

export type SvgProps = ComponentProps<typeof Svg>;
